unit CardPaymentPage.AuthPayment;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  PaymentPage,
  Data.DB,
  WEBLib.DB,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  Vcl.Controls,
  WEBLib.DBCtrls,
  WEBLib.ExtCtrls,
  WEBLib.Grids,
  WEBLib.WebCtrls,
  CustomerPage;

type
  TCardPaymentFormAuthPayment = class(TPaymentForm)
    procedure PaybyAltLabelClick(Sender: TObject);
  private
    FStripeSubscriptionId: string;
    FStripeCustomerId: string;
    [async]
    procedure PayByCardAuthPayment; async;
    [async]
    function CreateSubscriptionAuthPayment(Token: string): TJSObject; async;
    [async]
    function ConfirmSubscriptionAuthPayment(SubscriptionId: string): TJSObject; async;
    [async]
    procedure HandlePaymentSuccess(Response: TJSObject); async;
    procedure HandlePaymentError(ErrorMessage: string);
  protected
    [async]
    procedure PayNow; async; override;
  public
    [async]
    procedure InitForm; async; override;
  protected procedure LoadDFMValues; override; end;

var
  CardPaymentFormAuthPayment: TCardPaymentFormAuthPayment;

implementation

{$R *.dfm}

uses
  MainDataModule,
  Gadget.Web.Consts,
  Gadget.Enumerations;

{ TCardPaymentFormAuthPayment }

procedure TCardPaymentFormAuthPayment.InitForm;
var
  lKey: string;
begin
  inherited;

  {$IFDEF PAS2JS}
  asm
    console.log('CardPaymentFormAuthPayment.InitForm started');
  end;
  {$ENDIF}

  // Get the Stripe public key from server
  lKey := Await(MainData.StripePublicKey);
  
  {$IFDEF PAS2JS}
  asm
    console.log('CardPaymentFormAuthPayment: Got key from server:', lKey);
  end;
  {$ENDIF}

  {$IFDEF PAS2JS}
  asm
    console.log('CardPaymentFormAuthPayment: Initializing Stripe with key');
    // Initialize Stripe with AuthPayment support
    if (typeof StripeAuthPayment !== 'undefined') {
      StripeAuthPayment.init(lKey);
    } else if (typeof initStripe !== 'undefined') {
      initStripe(lKey);
    } else {
      console.error('Neither StripeAuthPayment nor initStripe available!');
    }
  end;
  {$ENDIF}
end;

procedure TCardPaymentFormAuthPayment.PaybyAltLabelClick(Sender: TObject);
begin
  ChangeSitePage(TGadgetPage.gpDirectDebit);
end;

procedure TCardPaymentFormAuthPayment.PayByCardAuthPayment;
begin
  {$IFDEF PAS2JS}
  asm
    console.log('PayByCardAuthPayment called');
    var form = this; // 'this' refers to Self in pas2js asm blocks

    // Define callbacks
    var createSubscriptionCallback = async function(token, callback) {
      try {
        var response = await form.CreateSubscriptionAuthPayment(token);
        callback(response);
      } catch (e) {
        callback({ status: 'error', errorMessage: e.message });
      }
    };

    var confirmSubscriptionCallback = async function(subscriptionId, callback) {
      try {
        var response = await form.ConfirmSubscriptionAuthPayment(subscriptionId);
        callback(response);
      } catch (e) {
        callback({ status: 'error', errorMessage: e.message });
      }
    };

    var successCallback = function(response) {
      form.HandlePaymentSuccess(response);
    };

    var errorCallback = function(errorMessage) {
      form.HandlePaymentError(errorMessage);
    };

    var on3DSCallback = function() {
      console.log('3D Secure authentication in progress...');
    };

    // Process payment with 3DS support
    if (typeof StripeAuthPayment !== 'undefined') {
      StripeAuthPayment.processPayment({
        createSubscription: createSubscriptionCallback,
        confirmSubscription: confirmSubscriptionCallback,
        onSuccess: successCallback,
        onError: errorCallback,
        on3DSRequired: on3DSCallback
      });
    } else {
      // Fallback to token-based flow
      GetToken(function(result) {
        if (result.startsWith('Error')) {
          errorCallback(result);
        } else {
          createSubscriptionCallback(result, function(response) {
            if (response.status === 'error') {
              errorCallback(response.errorMessage);
            } else {
              successCallback(response);
            }
          });
        }
      });
    }
  end;
  {$ENDIF}
end;

function TCardPaymentFormAuthPayment.CreateSubscriptionAuthPayment(Token: string): TJSObject;
begin
  Result := Await(TJSObject, MainData.StripeSubscriptionAuthPayment(Token));
end;

function TCardPaymentFormAuthPayment.ConfirmSubscriptionAuthPayment(SubscriptionId: string): TJSObject;
begin
  Result := Await(TJSObject, MainData.StripeConfirmAuthPayment(SubscriptionId));
end;

procedure TCardPaymentFormAuthPayment.HandlePaymentSuccess(Response: TJSObject);
var
  SubscriptionId, CustomerId, Status: string;
begin
  SubscriptionId := JS.ToString(Response['subscriptionId']);
  CustomerId := JS.ToString(Response['customerId']);
  Status := JS.ToString(Response['status']);

  FStripeSubscriptionId := SubscriptionId;
  FStripeCustomerId := CustomerId;

  // Save to CardData dataset via MainData (same pattern as original)
  Await(MainData.SaveStripePaymentAuthPayment(SubscriptionId, CustomerId, Status));

  // Proceed with payment completion
  MainData.AfterPaymentProcessed := AfterPaymentProcessed;
  MainData.UpdateBasketWithPayment(TPaymentProvider.Stripe);
end;

procedure TCardPaymentFormAuthPayment.HandlePaymentError(ErrorMessage: string);
begin
  // Reset form state so it can accept another payment attempt
  MainData.ResetAfterPaymentError;
  
  ShowMessage('Payment Error: ' + ErrorMessage);
end;

procedure TCardPaymentFormAuthPayment.PayNow;
begin
  {$IFDEF PAS2JS}
  asm
    console.log('TCardPaymentFormAuthPayment.PayNow called');
  end;
  {$ENDIF}
  inherited;
  PayByCardAuthPayment;
end;

procedure TCardPaymentFormAuthPayment.LoadDFMValues;
begin
  inherited LoadDFMValues;


  PaybyAltLabel.BeforeLoadDFMValues;
  MobileEdit.BeforeLoadDFMValues;
  EmailEdit.BeforeLoadDFMValues;
  LastNameEdit.BeforeLoadDFMValues;
  MarketingOKPanel.BeforeLoadDFMValues;
  MarketingOK.BeforeLoadDFMValues;
  PlaceOrderButton.BeforeLoadDFMValues;
  TermsOK.BeforeLoadDFMValues;
  try
    SetEvent(PaybyAltLabel, Self, 'OnClick', 'PaybyAltLabelClick');
    SetEvent(MobileEdit, Self, 'OnExit', 'nil');
    SetEvent(EmailEdit, Self, 'OnExit', 'nil');
    SetEvent(LastNameEdit, Self, 'OnExit', 'nil');
    MarketingOKPanel.Left := 311;
    MarketingOKPanel.Top := 477;
    MarketingOK.TabOrder := 10;
    PlaceOrderButton.TabOrder := 13;
    TermsOK.Left := 239;
    TermsOK.Top := 480;
    TermsOK.TabOrder := 11;
  finally
    PaybyAltLabel.AfterLoadDFMValues;
    MobileEdit.AfterLoadDFMValues;
    EmailEdit.AfterLoadDFMValues;
    LastNameEdit.AfterLoadDFMValues;
    MarketingOKPanel.AfterLoadDFMValues;
    MarketingOK.AfterLoadDFMValues;
    PlaceOrderButton.AfterLoadDFMValues;
    TermsOK.AfterLoadDFMValues;
  end;
end;

end.
